/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-12-06 14:35:38
 * @LastEditTime: 2021-12-06 16:36:43
 * @FilePath: /teacher-h5/src/utils/index.js
 */
export default {
  // 化学公式设置全局变量
  getMathjax() {
    return {
      MathJaxSrc: '//static.aixuexi.com/mathjax/MathJax.js?config=TeX-AMS-MML_HTMLorMML&delayStartupUntil=configured',
      mathjaxconfigSrc: '//q-fe.aixuexi.com/gs-mathjax/mathjaxconfig/mathjaxconfig.v3.js'
    }
  },
  appendScript(name, url) {
    let _url = ''
    return new Promise(resolve => {
      if (url === undefined) {
        _url = `/assets/libs/${name}`
      } else {
        _url = url
      }
      let script = document.getElementById(name)
      const isLoaded = script ? script.getAttribute('isLoaded') : false
      // 1. 未动态添加过该js
      if (!script) {
        script = document.createElement('script')
        script.id = name

        if (_url.indexOf('?') === -1) {
          script.src = _url + '?v=' + (Math.random() + '').replace('0.', '')
        } else {
          script.src = _url + '&v=' + (Math.random() + '').replace('0.', '')
        }
        document.body.appendChild(script)
        script.onload = () => {
          script.setAttribute('isLoaded', true)
          resolve()
        }
      } else if (script && !isLoaded) {
        // 2. 添加过但是未加载完成
        script.onload = () => {
          script.setAttribute('isLoaded', true)
          resolve()
        }
      } else {
        resolve()
      }
    })
  },
  /**
   * 初始化兼容PC和移动端保利威视播放器-HTML5
   * @param {*} wrapId
   * @param {*} options
   */
  initPlayer(wrapId, options) {
    if (!wrapId || !options.vid) {
      return false
    }

    const player = window.polyvPlayer({
      wrap: `#${wrapId}`,
      width: '100%',
      height: '100%',
      hideSwitchPlayer: true,
      autoplay: options.autoplay,
      speed: [0.5, 1.5, 1.7],
      statistics: {
        session_id: options.session_id
      },
      vid: options.vid,
      // 总时长超过多少分钟的视频记录播放进度
      history_video_duration: 0.5,
      allowFullscreen: options.allowFullscreen,
      ignoreIE: true,
      playsafe: options.playsafe,
      ts: options.ts,
      sign: options.sign
    })
    return player
  }
}

/**
 * 数组分组
 * @param {*} arr 原数组
 * @param {*} childLen 子数组的长度
 * @returns 分组后的数组
 */
export function getArrGroup(arr, childLen) {
  if (!arr.length) {
    return []
  }
  return arr.reduce(([groups, subIndex], item) => {
    // subIndex 为分组里的子数组的下标，范围为 [0, childLen]
    if (subIndex === 0) {
      groups.unshift([])
    }
    // 将元素加入到最近的一个分组中
    groups[0].push(item)

    return [groups, (subIndex + 1) % childLen]
  }, [[], 0])[0]
  // 前面 unshift 添加的组，所以需要做个反转
    .reverse()
}

/**
 *base64 转为 file
 * @param {*} dataurl
 * @param {*} filename
 */
export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

/**
 * 是否为数字
 * @param {*} str
 * @returns
 */
export function isNumeric(str) {
  if (typeof str != 'string') return false // we only process strings!
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

/**
 * 播放时长格式化
 * @param {*} duration 播放时间 单位秒
 * @returns
 */
export function formatDuration(duration) {
  const duartionInDays = duration % (24 * 60 * 60)
  const hours = parseInt(duartionInDays / 3600) + ''
  const minutes = parseInt((duartionInDays % 3600) / 60) + ''
  const seconds = parseInt((duartionInDays % 3600) % 60) + ''
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')} `
}